import ConfirmDeleteInsuranceCard from "./ConfirmDeleteInsuranceCard";

export default ConfirmDeleteInsuranceCard;

export * from "./ConfirmDeleteInsuranceCard";
